import type { LossReason, UpsertLossReasonCommand } from '@/domain/model/LossReason';
import type { LossReasonGateway } from '@/application/port/out/LossReasonGateway';
import type {
  ListLossReasonsUseCase, CreateLossReasonUseCase,
  UpdateLossReasonUseCase, DeleteLossReasonUseCase,
} from '@/application/port/in/LossReasonUseCase';

export class ListLossReasons implements ListLossReasonsUseCase {
  constructor(private readonly g: LossReasonGateway) {}
  execute(): Promise<LossReason[]> { return this.g.list(); }
}
export class CreateLossReason implements CreateLossReasonUseCase {
  constructor(private readonly g: LossReasonGateway) {}
  execute(cmd: UpsertLossReasonCommand): Promise<LossReason> { return this.g.create(cmd); }
}
export class UpdateLossReason implements UpdateLossReasonUseCase {
  constructor(private readonly g: LossReasonGateway) {}
  execute(id: string, cmd: UpsertLossReasonCommand): Promise<LossReason> { return this.g.update(id, cmd); }
}
export class DeleteLossReason implements DeleteLossReasonUseCase {
  constructor(private readonly g: LossReasonGateway) {}
  execute(id: string): Promise<void> { return this.g.remove(id); }
}
